export const TREATMENT_ROOMS_GROUP_NAME = 'Treatment rooms';

export const isTreatmentRoomsGroup = (group: unknown): boolean =>
  typeof group === 'string' && group === TREATMENT_ROOMS_GROUP_NAME;

type TreatmentRoomsResource = {
  GroupName?: string | null;
  BusinessId?: number | null;
};

export const homeHasTreatmentRooms = (
  homeBusinessId: number | null | undefined,
  resources: ReadonlyArray<TreatmentRoomsResource> | null | undefined,
): boolean =>
  !!homeBusinessId &&
  !!resources &&
  resources.some(
    (r) =>
      r.GroupName === TREATMENT_ROOMS_GROUP_NAME &&
      r.BusinessId === homeBusinessId,
  );
